import React from 'react'
import styles from './ImageOption.module.css'

const ImageOption = ( {src, name, handleSelection, value} ) => {
    return (
        <div className={styles.selectContainer}>
            <label className={styles.container}>
                <input 
                    type="radio" 
                    name={name}
                    onChange={handleSelection}
                    value={value}
                />
                <span className={styles.checkmark} > 
                    <img src={src} alt="bird" />
                </span>
            </label>
        </div>

    )
}

export default ImageOption
